import React from "react";
import { translate } from "../../../../../common/providers";
import styles from "./ReqDetails.module.css";

export default function ReqDetailsEmptyState() {
	return (
		<div className={styles["req-details__empty-state"]}>
			<div className={styles["req-details__empty-state-title"]}>
				{translate("requirement-matrix.req-details.empty-state.title")}
			</div>
			<div className={styles["req-details__empty-state-sub-title"]}>
				{translate("requirement-matrix.req-details.empty-state.content")}
			</div>
		</div>
	);
}
